module.exports = __webpack_public_path__ + "media/components/country-flag/static/co-70f5984f34209c104b227c5c67e24b2d.svg";